module.exports = __webpack_public_path__ + "static/media/Read-Light_V1100.831be951.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/read/Read-Light_V1100.woff
// module id = 920
// module chunks = 0